module.exports = __webpack_public_path__ + "static/SendBird-de04636e5b1456e671ff3ad2f2966097.jpg";